<template>
  <div class="detail" ref="detailComponent">
    <v-content v-if="job">
      <v-layout class="fill-height">
        <v-row>
          <v-col
            class="ma-0 pa-5 text-center"
            cols="12"
            sm="12"
            md="12"
            lg="8"
            xl="8"
          >
            <v-col cols="12" sm="12">
              <v-chip
                text-color="white"
                large
                style="height: 30px; border-radius: 15px !important"
                color="gray"
              >
                <v-avatar left>
                  <v-icon color="var(--primary)" small
                    >fiber_manual_record</v-icon
                  >
                </v-avatar>
                {{ job.name }}
              </v-chip>
            </v-col>
            <v-col cols="12" sm="12" offset-xl="2" xl="8" md="12">
              <VideoPlayer
                v-if="streamToken"
                :jumpToTimecode="jumpTo"
                :timecodeUpdateCallback="
                  (timecode) => (currentTimecode = timecode)
                "
                :source="$store.state.api + '/stream/' + streamToken"
                :job="job"
              />
            </v-col>
            <v-col
              cols="10"
              xl="10"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="text-right"
            >
              <ApprovalButtons
                :job="job"
                :callback="approvalCallback"
              ></ApprovalButtons>
            </v-col>
            <template id="commentSection" v-if="$checkAccess(job, 'COMMENT')">
              <v-col
                cols="12"
                xl="12"
                md="12"
                xs="12"
                offset-xl="2"
                class="text-left"
              >
                <v-chip
                  class="cursor-pointer"
                  text-color="white"
                  x-small
                  style="
                    border: 1px solid var(--primary);
                    border-radius: 15px !important;
                    height: 30px;
                  "
                  @click="setInPoint"
                  :color="
                    inPointSet ? 'var(--primary)' : 'var(--primary-background)'
                  "
                  :close="inPointSet"
                  close-icon="cancel"
                  @click:close="removeInPoint"
                >
                  <v-avatar left
                    ><strong style="font-size: 12px">IN</strong></v-avatar
                  >
                  <strong style="font-size: 14px">{{ inPoint }}</strong>
                </v-chip>
                <v-icon color="primary" class="ml-3 mr-3" small
                  >valve-closed</v-icon
                >
                <v-chip
                  class="cursor-pointer local-chip-InOut"
                  text-color="white"
                  x-small
                  style="
                    border: 1px solid var(--attention);
                    border-radius: 15px !important;
                    height: 30px;
                  "
                  @click="setOutPoint"
                  :color="
                    outPointSet
                      ? 'var(--attention)'
                      : 'var(--primary-background)'
                  "
                  :close="outPointSet"
                  close-icon="cancel"
                  @click:close="removeOutPoint"
                >
                  <v-avatar left
                    ><strong style="font-size: 12px">OUT</strong></v-avatar
                  >
                  <strong style="font-size: 14px">{{ outPoint }}</strong>
                </v-chip>
              </v-col>
              <v-col cols="12" xl="8" offset-xl="2" xs="12" md="12">
                <v-col
                  v-if="replyId"
                  style="margin-left: -40px"
                  cols="12"
                  xs="12"
                  class="text-right"
                >
                  <v-icon small>reply</v-icon>
                  {{ $t("views.detailView.replyTo") }}
                  {{ getReplyById(replyId).email }} -
                  {{ getReplyById(replyId).createDate | formatDateTime }}
                  <v-icon small color="primary" @click="replyId = null"
                    >delete</v-icon
                  >
                </v-col>
                <v-col
                  v-else-if="editId"
                  style="margin-left: -40px"
                  cols="12"
                  xs="12"
                  class="text-right"
                >
                  <v-icon small>edit</v-icon>
                  {{ $t("views.detailView.editOfComment") }}
                  {{ getReplyById(editId).email }} -
                  {{ getReplyById(editId).createDate | formatDateTime }}
                  <v-icon
                    color="primary"
                    class="mb-2"
                    @click="
                      () => {
                        editId = null;
                        comment = '';
                      }
                    "
                    >highlight_off</v-icon
                  >
                </v-col>
                <v-textarea
                  name="comment"
                  id="commentTextArea"
                  filled
                  :rows="4"
                  v-model="comment"
                  :label="$t('views.detailView.textAreaLabel')"
                  @keydown="keyStrokeSendComment($event)"
                >
                  <template v-slot:append>
                    <v-icon
                      :color="comment.length ? 'primary' : 'grey'"
                      :disabled="!comment.length"
                      @click="sendComment"
                      class="ml-3 mr-3 cursor-pointer"
                      >send</v-icon
                    >
                    <br />
                    <v-icon
                      v-if="$vuetify.breakpoint.lgAndUp"
                      :color="emoji ? 'primary' : 'grey'"
                      @click="displayEmojiSection"
                      class="cursor-pointer"
                      >sentiment_satisfied_alt</v-icon
                    >
                  </template>
                </v-textarea>
                <div v-if="$vuetify.breakpoint.lgAndUp">
                  <VEmojiPicker
                    v-if="emoji"
                    :emojisByRow="25"
                    :dark="true"
                    :emojiSize="25"
                    @select="(v) => (comment += v.data)"
                  ></VEmojiPicker>
                </div>
              </v-col>
            </template>
          </v-col>

          <v-col class="ma-0 pa-0" fill-height cols="12" xl="4" md="12">
            <v-col cols="12" xs="12">
              <v-card
                style="
                  min-height: 90vh;
                  height: 100%;
                  background-color: var(--primary-background-third);
                "
              >
                <v-card-title
                  class="pt-5 pl-5 pb-10"
                  style="
                    border-bottom: 2px solid var(--primary-background) !important;
                  "
                >
                  <v-icon small color="var(--primary)">chat_bubble </v-icon>
                  <span class="ml-5">{{
                    $t("views.detailView.commentsHeader")
                  }}</span>
                </v-card-title>

                <v-card-text class="mt-3">
                  <v-row
                    dense
                    style="
                      border-bottom: 2px solid var(--primary-background) !important;
                    "
                  >
                    <v-spacer></v-spacer>
                    <v-col cols="3" md="4" dense class="pt-3">
                      {{ $t("views.detailView.sortBy") }}
                    </v-col>
                    <v-col cols="3" dense>
                      <v-select
                        style="font-size: 12px"
                        dense
                        outlined
                        filled
                        background-color="var(--primary-background)"
                        v-model="commentsSort"
                        :items="commentsSortItems"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-col
                    class="pa-0 ma-0"
                    cols="12"
                    xs="12"
                    v-for="comment in comments"
                    :key="comment.id"
                    style="
                      border-bottom: 2px solid var(--primary-background) !important;
                    "
                  >
                    <Comment
                      :jumpToCallback="
                        (v) => {
                          jumpTo = v;
                        }
                      "
                      :editCallback="editCallback"
                      :replyCallback="replyCallback"
                      :comment="comment"
                      :job="job"
                    />
                  </v-col>
                </v-card-text>

                <!-- <v-tabs grow>
                  <v-tab>
                    <template v-slot:default>
                      <v-avatar left>
                        <v-icon color="primary" small
                          >mdi-message</v-icon
                        > </v-avatar
                      >Comments
                    </template>
                  </v-tab>
                  <v-tab>
                    <template v-slot:default>
                      <v-avatar left>
                        <v-icon color="primary" small
                          >mdi-information</v-icon
                        > </v-avatar
                      >Sharing
                    </template>
                  </v-tab>
                  <v-tab>
                    <template v-slot:default>
                      <v-avatar left>
                        <v-icon color="primary" small
                          >mdi-note-text</v-icon
                        > </v-avatar
                      >Metadata
                    </template>
                  </v-tab>

                  <v-tab-item>
                    <v-card flat>
                      <div style="height: 50px"></div>
                      <v-card-text v-if="forceUpdate" class="pa-0">
                        <v-col
                          class="pa-0 ma-0"
                          cols="12"
                          xs="12"
                          v-for="comment in comments"
                          :key="comment.id"
                        >
                          <Comment
                            :jumpToCallback="
                              (v) => {
                                jumpTo = v;
                              }
                            "
                            :editCallback="editCallback"
                            :replyCallback="replyCallback"
                            :comment="comment"
                            :job="job"
                          />
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <div style="height: 50px"></div>
                      <v-card-text>
                        <div>
                          <v-row>
                            <v-col cols="11">
                              <div>
                                <v-text-field
                                  label="Total Visits"
                                  :value="job.visits"
                                  readonly
                                ></v-text-field>
                              </div>
                              <div v-if="jobToken(job)">
                                <v-text-field
                                  v-if="jobToken(job).viewCount"
                                  label="Views"
                                  :value="jobToken(job).viewCount"
                                  readonly
                                ></v-text-field>
                              </div>
                              <div v-if="jobToken(job)">
                                <v-text-field
                                  v-if="jobToken(job).expiringDate"
                                  label="Views"
                                  :value="jobToken(job).expiringDate"
                                  readonly
                                ></v-text-field>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <div style="height: 50px"></div>
                        <div>
                          <v-row>
                            <v-col cols="11">
                              <div class="cursor-pointer" v-if="job">
                                <v-text-field
                                  class="textFieldPointer"
                                  label="JobId"
                                  :value="job._id"
                                  readonly
                                  @click="copyValue(job._id)"
                                ></v-text-field>
                              </div>
                              <div
                                v-if="job && job.metadata"
                                class="cursor-pointer"
                              >
                                <div
                                  v-for="key in Object.keys(job.metadata)"
                                  :key="key"
                                >
                                  <v-text-field
                                    class="textFieldPointer"
                                    v-if="key === 'Upload Date'"
                                    :key="key"
                                    :label="key"
                                    :value="job.metadata[key] | formatDateTime"
                                    readonly
                                    @click="copyValue(job.metadata[key])"
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    class="textFieldPointer"
                                    :key="key"
                                    :label="key"
                                    :value="job.metadata[key]"
                                    readonly
                                    @click="copyValue(job.metadata[key])"
                                  ></v-text-field>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs> -->
              </v-card>
            </v-col>
          </v-col>
        </v-row>
      </v-layout>
    </v-content>
  </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayerV2";
import Comment from "@/components/Details/Comment";
import ApprovalButtons from "@/components/Details/ApprovalButtons";
import StatusConverter from "@/mixins/StatusConverter";
import AccessChecker from "@/mixins/AccessChecker";
import VEmojiPicker from "v-emoji-picker";
import jwt_decode from "jwt-decode";

export default {
  name: "DetailComponent",
  data: () => {
    return {
      commentsSort: "Newest First",
      commentsSortItems: ["Newest First"],
      job: {},
      comments: [],
      emoji: false,
      streamToken: null,
      accessToken: null,
      jumpTo: "00:00:00:00",
      replyId: null,
      editId: null,
      comment: "",
      currentTimecode: "00:00:00:00",
      inPoint: "00:00:00:00",
      outPoint: "00:00:00:00",
      inPointSet: false,
      outPointSet: false,
      forceUpdate: true,
    };
  },

  props: {
    jobId: {
      type: String,
      default: null,
    },
  },

  components: { VideoPlayer, Comment, VEmojiPicker, ApprovalButtons },

  mixins: [StatusConverter, AccessChecker],

  computed: {
    jobs() {
      return this.$store.getters.getJobs;
    },
    storeComments() {
      return this.$store.getters.getComments;
    },
  },

  watch: {
    storeComments(v) {
      this.comments = v;
    },
    emoji(v) {
      if (v) {
        setTimeout(() => {
          this.initializeEmojiComponent();
        }, 100);
      }
    },
    jobs(value) {
      this.job = value.find((v) => v._id === this.job._id);
      this.forceUpdate = false;
      this.$nextTick(() => {
        this.forceUpdate = true;
      });
    },
  },

  methods: {
    //example on how to programmatically insert emoji
    test() {
      this.comment = String.fromCodePoint(0x1f525);
    },
    approvalCallback(updatedJob) {
      this.job = updatedJob;
    },
    handleInvalidJWT(path, userCommingFromMail, namespace) {
      this.$store.state.user = null;
      this.$store.state.jwt = null;
      localStorage.setItem("requestUrl", path);
      localStorage.setItem("requestor", userCommingFromMail);
      localStorage.setItem("targetNamespace", namespace);
      this.$router.push({ name: "Login" }).catch(() => {
        // to avoid NavigationDuplicated Navigating to current location /login is not allowed
      });
    },
    checkExistingJWT(jwt, requestingUser, namespace) {
      var jwtUser = jwt_decode(jwt);
      // first check for user to be guest user -> then redirect to login since requestor is internal one
      console.log("jwtUser", jwtUser);
      console.log("namespace", namespace);
      if (jwtUser.namespaces) {
        console.log("guest user token pending");
        return false;
      } else {
        if (
          jwtUser.email === requestingUser &&
          jwtUser.activeNamespace === namespace
        ) {
          console.log("User and namespace matches -> valid");
          return true;
        } else {
          console.log("User and namespace not matching");
          return false;
        }
      }
    },
    keyStrokeSendComment(event) {
      if (event.keyCode == 13 && event.ctrlKey && event.target.value.length) {
        this.sendComment();
      }
    },
    keydown(event) {
      if (document.activeElement.id != "commentTextArea") {
        switch (event.keyCode) {
          case 73:
            if (event.altKey) {
              this.removeInPoint();
            } else {
              this.setInPoint();
            }
            break;
          case 79:
            if (event.altKey) {
              this.removeOutPoint();
            } else {
              this.setOutPoint();
            }
            break;
          case 88: {
            if (event.altKey) {
              this.removeInPoint();
              this.removeOutPoint();
            }
          }
        }
      }
    },
    setInPoint() {
      this.inPoint = this.currentTimecode;
      this.inPointSet = true;
      console.log(this.inPoint, this.outPoint, this.outPoint < this.inPoint);
      if (this.outPoint && this.outPointSet && this.outPoint < this.inPoint) {
        console.log(this.currentTimecode);
        this.outPoint = this.currentTimecode;
      }
    },
    removeInPoint() {
      this.inPoint = "00:00:00:00";
      this.inPointSet = false;
    },
    setOutPoint() {
      this.outPoint = this.currentTimecode;
      this.outPointSet = true;
      if (this.inPoint && this.inPointSet && this.inPoint > this.outPoint) {
        this.inPoint = this.currentTimecode;
      }
    },
    removeOutPoint() {
      this.outPoint = "00:00:00:00";
      this.outPointSet = false;
    },
    displayEmojiSection() {
      this.emoji = this.emoji ? false : true;
      setTimeout(() => {
        if (this.emoji) {
          window.scrollBy(
            0,
            document.body.scrollHeight || document.documentElement.scrollHeight
          );
        } else {
          window.scrollBy(
            0,
            -document.body.scrollHeight ||
              -document.documentElement.scrollHeight
          );
        }
      }, 500);
    },
    initializeEmojiComponent() {
      var component = document.getElementsByClassName("container-emoji");
      if (component[0]) {
        component = component[0];
        component.style.height = "400px";
        component.style.overflow = "hidden";
      }
    },
    copyValue(value) {
      navigator.clipboard.writeText(value);
      this.$store.commit("setSnackbar", {
        text: "Value copied",
      });
    },
    jobToken(job) {
      if (this.accessToken) {
        if (job && job.tokens) {
          return job.tokens.find((t) => t.token === this.accessToken);
        }
        return false;
      }
      return false;
    },
    getReplyById(id) {
      var parentComment = this.comments.find((c) => c.id === id);
      if (!parentComment) {
        var replyComment = "";
        this.comments.forEach((c) => {
          if (c.replies.find((r) => r.id === id)) {
            replyComment = c.replies.find((r) => r.id === id);
          }
        });
        return replyComment;
      }
      return parentComment;
    },
    isReply(id) {
      var parentComment = this.comments.find((c) => c.id === id);
      if (!parentComment) {
        return true;
      }
      return false;
    },
    replyCallback(commentId) {
      document.getElementById("commentTextArea").blur();
      setTimeout(() => {
        document.getElementById("commentTextArea").focus();
      }, 500);
      this.editId = null;
      this.comment = "";
      this.replyId = commentId;
    },
    editCallback(commentObj) {
      document.getElementById("commentTextArea").blur();
      setTimeout(() => {
        document.getElementById("commentTextArea").focus();
      }, 500);
      this.replyId = null;
      this.editId = commentObj.id;
      this.comment = commentObj.comment;
      if (commentObj.inPoint) {
        this.inPoint = commentObj.inPoint;
        this.inPointSet = true;
      }
      if (commentObj.outPoint) {
        this.outPoint = commentObj.outPoint;
        this.outPointSet = true;
      }
    },
    sendComment() {
      if (this.editId) {
        var editObj = {
          comment: this.comment,
          id: this.editId,
          inPoint: this.inPointSet?this.inPoint:null,
          outPoint: this.outPointSet?this.outPoint:null,
          isReply: this.isReply(this.editId),
        };

        this.$http
          .patch(
            this.$store.state.api + "/comment/" + this.job._id,
            editObj,
            this.$store.getters.getAuthorizationHeader
          )
          .then((response) => {
            response;
            // this.comments = response.data.comments;
            // this.comments = this.comments.map((c) =>
            //   c.id === response.data.id ? response.data : c
            // );
            this.editId = null;
            this.comment = "";
            this.resetComment();
          })
          .catch((error) => {
            this.$store.commit("setSnackbar", {
              text: error.response.data.message,
              color: "var(--attention)",
            });
          });
      } else {
        if (this.outPointSet && !this.inPointSet) {
          this.$store.commit("setSnackbar", {
            text: "OUT point requires an IN point to be set",
            color: "var(--attention)",
          });
          return;
        }
        if (this.inPointSet && this.outPointSet) {
          if (
            parseInt(this.inPoint.replace(/:/g, "")) >
            parseInt(this.outPoint.replace(/:/g, ""))
          ) {
            this.$store.commit("setSnackbar", {
              text: "OUT point must be after or equal to IN point",
              color: "var(--attention)",
            });
            return;
          }
        }
        if (this.inPointSet && !this.outPointSet) {
          this.outPoint = this.inPoint;
        }

        // save comment
        var cmt = { comment: this.comment };
        if (this.inPointSet) {
          cmt.inPoint = this.inPoint;
        }
        if (this.outPointSet) {
          cmt.outPoint = this.outPoint;
        }

        if (this.replyId) {
          cmt.id = this.replyId;
        }

        this.$http
          .post(
            this.$store.state.api + "/comment/" + this.job._id,
            cmt,
            this.$store.getters.getAuthorizationHeader
          )
          .then((response) => {
            if (this.replyId) {
              this.comments = this.comments.map((c) =>
                c.id === response.data.id ? response.data : c
              );
            } else {
              // this.comments.push(response.data);
            }
            this.resetComment();
          });
      }
    },
    resetComment() {
      this.replyId = null;
      this.editId = null;
      this.comment = "";
      this.inPoint = "00:00:00:00";
      this.outPoint = "00:00:00:00";
      this.inPointSet = false;
      this.outPointSet = false;
    },
  },

  created() {
    // Opened link from email for internal users
    // Will grab user query parameter and compare it with store user, if equal, nothing to do.
    // If not equal route to login and delete jwt but save request url to navigate directly to
    // the requested job after login.
    var userCommingFromMail = this.$route.query.user;
    var namespace = this.$route.query.namespace;

    if (userCommingFromMail) {
      console.log(
        "Internal user requests via email. Existing token: ",
        localStorage.getItem("jwt"),
        "of type",
        typeof localStorage.getItem("jwt")
      );
      if (
        localStorage.getItem("jwt") &&
        localStorage.getItem("jwt") != "null"
      ) {
        console.log("Existing JWT -> check if usable connection");
        if (
          this.checkExistingJWT(
            localStorage.getItem("jwt"),
            userCommingFromMail,
            namespace
          )
        ) {
          console.log("Existing JWT successfully verified");
          this.$router.push(this.$route.path);
        } else {
          console.log("Existing JWT invalid -> push to login");
          this.handleInvalidJWT(
            this.$route.path,
            userCommingFromMail,
            namespace
          );
        }
      } else {
        console.log("No existing JWT found -> push to login");
        this.handleInvalidJWT(this.$route.path, userCommingFromMail, namespace);
      }
    }
  },

  mounted() {
    if (this.$store.state.jwt) {
      document.addEventListener("keydown", this.keydown);
      this.accessToken = this.$route.params.token;
      if (this.$props.jobId) {
        this.$http
          .get(
            this.$store.state.api + "/job/" + this.$props.jobId,
            this.$store.getters.getAuthorizationHeader
          )
          .then((response) => {
            this.job = response.data;

            this.$http
              .get(
                this.$store.state.api + "/comment/" + this.job._id,
                this.$store.getters.getAuthorizationHeader
              )
              .then((response) => {
                this.comments = response.data;
                this.$store.commit("setComments", this.comments);
              })
              .catch(() => {
                // this.$store.commit("setSnackbar", {
                //   text: error.response.data.message,
                //   color: "var(--attention)",
                // });
              });
          })
          .catch((error) => {
            this.$store.commit("setSnackbar", {
              text: error.response.data.message,
              color: "var(--attention)",
            });
          });
        this.$http
          .get(
            this.$store.state.api +
              "/stream/" +
              this.$props.jobId +
              "/generateToken",
            this.$store.getters.getAuthorizationHeader
          )
          .then((response) => {
            this.streamToken = response.data.token;
          })
          .catch((error) => {
            this.$store.commit("setSnackbar", {
              text: error.response.data.message,
              color: "var(--attention)",
            });
          });
      }
    }
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.keydown);
  },
};
</script>

<style scoped>
.emoji-picker {
  width: 800px !important;
  /* height: 600px !important; */
  /* background-color: var(--primary-background-second) !important; */
  overflow-y: hidden !important;
}
</style>
